import UrlGeneration from '@lovata/url-generation';

/**
 * @author  Andrey Kharanenka, a.khoronenko@lovata.com, LOVATA Group
 */
/**
 * Represents a class for managing the configuration of a Shopaholic product list.
 */
export default class ShopaholicPagination {
	/**
	 * Constructs a new ShopaholicPagination instance.
	 * @param {ShopaholicProductList} obProductListHelper - The ShopaholicProductList helper object.
	 */
	constructor(obProductListHelper = null) {
		this.obProductListHelper = obProductListHelper;
		this.sEventType = 'click';
		this.sFieldName = 'page';
		this.sAttributeName = 'data-page';
		this.sDefaultWrapperClass = '_shopaholic-list-wrapper';
		this.sDefaultButtonClass = '_shopaholic-pagination';
	}

	/**
	 * Initializes event handlers for the default wrapper class.
	 */
	init() {
		const wrapper = document.querySelector(`.${this.sDefaultWrapperClass}`);
		if (!wrapper) {
			return;
		}
		wrapper.addEventListener(this.sEventType, (obEvent) => {
			if (obEvent.target.classList.contains(this.sDefaultButtonClass) && obEvent.target.tagName === 'A') {
				obEvent.preventDefault();
				obEvent.stopPropagation();
				const obButton = obEvent.target;
				const iPage = obButton.getAttribute(this.sAttributeName);

				// Initialize UrlGeneration
				UrlGeneration.init();

				// Check if iPage is equal to 1
				if (iPage === 1) {
					// Remove the specified field from UrlGeneration
					UrlGeneration.remove(this.sFieldName);
				} else {
					// Set the specified field in UrlGeneration with the value of iPage as an array
					UrlGeneration.set(this.sFieldName, [iPage]);
				}

				// Update the URL
				UrlGeneration.update();

				// Check if obProductListHelper exists
				if (!this.obProductListHelper) {
					return;
				}
				document.querySelector(`.${this.sDefaultWrapperClass}`).scrollIntoView({behavior:'smooth'});

				// Send the product list
				this.obProductListHelper.send();
			}
		});
	}

	/**
	 * Redeclare default selector of pagination button.
	 * @param {string} sButtonSelector - The class name of the pagination button.
	 * @returns {ShopaholicPagination} - The ShopaholicPagination instance.
	 */
	setButtonSelectorClass(sButtonSelector) {
		this.sDefaultButtonClass = sButtonSelector;
		return this;
	}

	/**
	 * Set the event type.
	 * @param {string} eventType - The type of event to listen for.
	 * @returns {ShopaholicPagination} - The ShopaholicPagination instance.
	 */
	setEventType(eventType) {
		this.sEventType = eventType;
		return this;
	}

	/**
	 * Set the field name.
	 * @param {string} fieldName - The name of the field.
	 * @returns {ShopaholicPagination} - The ShopaholicPagination instance.
	 */
	setFieldName(fieldName) {
		this.sFieldName = fieldName;
		return this;
	}

	/**
	 * Set the attribute name.
	 * @param {string} attributeName - The name of the attribute.
	 * @returns {ShopaholicPagination} - The ShopaholicPagination instance.
	 */
	setAttributeName(attributeName) {
		this.sAttributeName = attributeName;
		return this;
	}

	/**
	 * Set the default wrapper class.
	 * @param {string} wrapperClass - The class name of the wrapper element.
	 * @returns {ShopaholicPagination} - The ShopaholicPagination instance.
	 */
	setDefaultWrapperClass(wrapperClass) {
		this.sDefaultWrapperClass = wrapperClass;
		return this;
	}
}
